/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GenerateStructuredOutputRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'
import {GenerateStructuredOutputResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'


export const generateStructuredOutput = (request: GenerateStructuredOutputRequest, options?: CashRequestOptions) => post<GenerateStructuredOutputRequest, GenerateStructuredOutputResponse>("/2.0/cash/generate-structured-output", request, {...options, rejectOnError: true })